((window) => {
    class CKEditorService {
        constructor() {
            this.editor = null;
            window.CKEDITOR.on('instanceReady', (ev) => this.editor = ev.editor);
        }

        insertHTML(value) {
            if (!this.editor) {
                throw new Error("The editor is not ready");
            }
            this.editor.insertHtml(value, 'text');
        }
    }

    angular.module('dashboard')
        .service('CKEditorService', [ CKEditorService ])
})(window);
